export const SEMI_DONUT_CHART_MAX_ANGLE = 180;
export const SEMI_DONUT_CHART_ARROW_DEFAULT_ANGLE = 90;
